import { render, staticRenderFns } from "./DocumentComponent.vue?vue&type=template&id=4f031a66&scoped=true"
import script from "./DocumentComponent.vue?vue&type=script&lang=js"
export * from "./DocumentComponent.vue?vue&type=script&lang=js"
import style0 from "./DocumentComponent.vue?vue&type=style&index=0&id=4f031a66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f031a66",
  null
  
)

export default component.exports